// @flow
import {
  COMPANY_DETAILS_REQUEST,
  COMPANY_DETAILS_ERROR,
  COMPANY_DETAILS_UPDATE,
  COMPANY_DETAILS_RESET,
  FACILITIES_DETAILS_REQUEST,
  FACILITIES_DETAILS_ERROR,
  FACILITIES_DETAILS_UPDATE
} from './constants';

import type {
  Action, Company, Worker, Photo, Facility
} from '../types';

export const requestCompanyDetails = (slug: string): Action => ({
  type: COMPANY_DETAILS_REQUEST,
  slug
});

export const errorCompanyDetails = (error: Error): Action => ({
  type: COMPANY_DETAILS_ERROR,
  error
});

export const updateCompanyDetails = (data: Company, included: Array<Photo | Worker>): Action => ({
  type: COMPANY_DETAILS_UPDATE,
  data,
  included
});

export const resetCompanyDetails = (): Action => ({ type: COMPANY_DETAILS_RESET });

export const requestFacilitiesDetails = (id: string, perPage: number): Action => ({
  type: FACILITIES_DETAILS_REQUEST,
  id,
  perPage
});

export const errorFacilitiesDetails = (error: Error): Action => ({
  type: FACILITIES_DETAILS_ERROR,
  error
});

export const updateFacilitiesDetails = (
  data: Array<Facility>,
  included: Array<Photo | Worker>
): Action => ({
  type: FACILITIES_DETAILS_UPDATE,
  data,
  included
});
